"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_MASK = exports.NNPF_OFFER_LINK = exports.NNPF_BONUS_CONDITIONS = exports.END_USER_LICENSE_AGREEMENT = exports.CONSENT_FOR_PROCESSING_PERSONAL = exports.CONSENT_FOR_ADVERTISING = exports.BANKRUPTCY_CONSENT_FOR_PROCESSING_PERSONAL = void 0;
/** MASKS */

var PHONE_MASK = ['+', '7', ' ', '(', '9', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

/** DOCUMENT LINKS */
exports.PHONE_MASK = PHONE_MASK;
var CONSENT_FOR_PROCESSING_PERSONAL = 'https://www.sravni.ru/promo/soglasie-na-obrabotku-personalnyh-dannyh/';
exports.CONSENT_FOR_PROCESSING_PERSONAL = CONSENT_FOR_PROCESSING_PERSONAL;
var END_USER_LICENSE_AGREEMENT = 'https://www.sravni.ru/promo/polzovatelskoe-soglashenie/';
exports.END_USER_LICENSE_AGREEMENT = END_USER_LICENSE_AGREEMENT;
var BANKRUPTCY_CONSENT_FOR_PROCESSING_PERSONAL = 'https://www.sravni.ru/promo/soglasie-na-obrabotku-personalnyh-dannyh-bankrotstvo/';
exports.BANKRUPTCY_CONSENT_FOR_PROCESSING_PERSONAL = BANKRUPTCY_CONSENT_FOR_PROCESSING_PERSONAL;
var NNPF_BONUS_CONDITIONS = 'https://f.sravni.ru/cms/file/FilePath/bonus_nnpf.pdf';
exports.NNPF_BONUS_CONDITIONS = NNPF_BONUS_CONDITIONS;
var NNPF_OFFER_LINK = 'https://offerback.nnpf.ru/?utm_source=sravni&utm_content=promo&pcode=231956255';
exports.NNPF_OFFER_LINK = NNPF_OFFER_LINK;
var CONSENT_FOR_ADVERTISING = 'https://f.sravni.ru/cms/file/FilePath/soglasie-na-poluchenie-reklamy.pdf';
exports.CONSENT_FOR_ADVERTISING = CONSENT_FOR_ADVERTISING;